/**
 * Пользователь. Модуль для работы с API
 * @module units
 */

/**
 * Получение списка всех РГ, в которых пользователь является руководителем
 * @returns {Promise} - список РГ
 * @throws {Error} - ошибка при получении данных
 */
export const getManagedUnits = async () => {
  try {
    const response = await fetch("/api/my/managed-units", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`,
      );
    }

    return data.units;
  } catch (err) {
    throw err;
  }
};
